import axios from '@/interceptor';

class Captcha {
  constructor() {
    // this.captcha_hash = '';
    // this.image_base64 = '';
    // this.timestamp = '';
		this.phone_number = '';
  }

  static getCaptcha() {
    const url = process.env.VUE_APP_API_URL + 'auth/gen_captcha';
    return axios.post(url).then((res) => {
      return res.data;
    });
  }

	static sendSMSCode(data) {
    
    const url = process.env.VUE_APP_API_URL +'auth/smscode';
    return axios.post(url, data).then((res) => {
      return true;
    }).catch((error) => {
			return false;
		});
  }
}

export default Captcha;
export { Captcha };
